const highglightStart = '{% html-highlighter %}';
const highlightEnd = '{% /html-highlighter %}';

const highlightText = (content: string) => {
  return `${highglightStart}${content}${highlightEnd}`;
};

export { highglightStart, highlightEnd, highlightText };
